import { render, staticRenderFns } from "./GoliaLoader.vue?vue&type=template&id=66556e5d"
import script from "./GoliaLoader.vue?vue&type=script&lang=js"
export * from "./GoliaLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports